import { IssueReviewStatusEnum } from '@issuemanager/constants';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface SelectOption {
  label: string;
  value: string;
}

export const useReviewStatusOptions = (): SelectOption[] => {
  const { t } = useTranslation('common');

  return useMemo(
    () => [
      {
        label: t('issueReviewStatus.notSet'),
        value: IssueReviewStatusEnum.NOT_SET,
      },
      {
        label: t('issueReviewStatus.inReview'),
        value: IssueReviewStatusEnum.IN_REVIEW,
      },
      {
        label: t('issueReviewStatus.toBePublished'),
        value: IssueReviewStatusEnum.TO_BE_PUBLISHED,
      },
      {
        label: t('issueReviewStatus.pendingAcceptance'),
        value: IssueReviewStatusEnum.PENDING_ACCEPTANCE,
      },
      {
        label: t('issueReviewStatus.accepted'),
        value: IssueReviewStatusEnum.ACCEPTED,
      },
    ],
    [t],
  );
};
